"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSwipe = void 0;
var react_1 = require("react");
// A custom hook for handling swipe gestures.
var useSwipe = function (_a) {
    var isTouchDevice = _a.isTouchDevice, onSlide = _a.onSlide;
    var isSliding = (0, react_1.useRef)(false); // A reference to track if sliding is happening or not.
    var dragStartX = (0, react_1.useRef)(null); // A reference to track the start position of the drag.
    var dragDistance = (0, react_1.useRef)(0); // A reference to track the distance of the drag.
    //Handles the start of the drag gesture.
    var handleDragStart = function (e) {
        e.preventDefault();
        // Set the initial drag start position
        dragStartX.current = isTouchDevice.current ? e.touches[0].clientX : e.clientX;
        // Reset the drag distance
        dragDistance.current = 0;
        // Set the sliding flag to false
        isSliding.current = false;
        // Add event listeners for touch or mouse move and end events
        if (isTouchDevice.current) {
            document.body.addEventListener('touchmove', handleDragMove, { passive: false });
            document.body.addEventListener('touchend', handleDragEnd);
        }
        else {
            document.body.addEventListener('mousemove', handleDragMove);
            document.body.addEventListener('mouseup', handleDragEnd);
        }
    };
    //Handles the move of the drag gesture.
    var handleDragMove = function (e) {
        // Get the clientX value based on the device type
        var clientX = isTouchDevice.current ? e.touches[0].clientX : e.clientX;
        // Calculate the drag distance
        dragDistance.current = clientX - dragStartX.current;
        // Check if sliding is happening
        if (Math.abs(dragDistance.current) > 20 && !isSliding.current) {
            // Determine the direction of the slide
            var direction = dragDistance.current > 0 ? 'left' : 'right';
            // Call the onSlide function with the direction
            onSlide(direction);
            // Reset the drag start position and distance
            dragStartX.current = clientX;
            dragDistance.current = 0;
            // Set the sliding flag
            isSliding.current = true;
        }
    };
    // Handles the end of the drag gesture.
    var handleDragEnd = function () {
        // Remove event listeners based on device type
        if (isTouchDevice.current) {
            document.body.removeEventListener('touchmove', handleDragMove);
            document.body.removeEventListener('touchend', handleDragEnd);
        }
        else {
            document.body.removeEventListener('mousemove', handleDragMove);
            document.body.removeEventListener('mouseup', handleDragEnd);
        }
        // Reset drag start coordinates, drag distance, and sliding flag
        dragStartX.current = null;
        dragDistance.current = 0;
        isSliding.current = false;
    };
    return {
        handleDragStart: handleDragStart,
    };
};
exports.useSwipe = useSwipe;
